export const getToken = (state) => state.login.loginUser.token;
export const getClockInAuth = (state) => state.clockIn.clockInAuth;
